import React, { useEffect } from 'react';
import OPNFaucet from './components/OPNFaucet';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-Q36JZ74KK8');

function App() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);
  
  return <OPNFaucet />;
}

export default App;